import confirmMarkAsPhishing from './helpers/confirmMarkAsPhishing';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import markItemsAsPhishingBasedOnItemIds from './helpers/markItemsAsPhishingBasedOnItemIds';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { mailStore } from 'owa-mail-store';
import { select } from 'satcheljs/lib/legacy';
/**
 * Mark item as phishing from reading pane
 * @param itemId of the item to be marked as phishing
 * @param actionSource that triggers the action
 */
export default select({
    item: function (itemId) { return mailStore.items.get(itemId); },
})(function markItemsAsPhishingFromReadingPane(itemId, actionSource, state) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing(function () {
        markItemsAsPhishingBasedOnItemIds([itemId], actionSource, function () {
            var itemContexts = createItemContextsForDeleteStoreUpdate([itemId]);
            // Dispatch action to update the store state
            deleteItemsStoreUpdate(itemContexts, state.item.ParentFolderId.Id);
        });
    });
});
//# sourceMappingURL=markItemAsPhishingFromReadingPane.js.map